import o from"../../package.json";const n=o.version,r=!!window;export{n as LIB_VERSION,r as isH5};
